import React, { useState, useEffect } from "react";
import { Zoom, useMediaQuery } from "@mui/material";
import styles from "../styles/Home.module.css";
import { useTranslation } from "react-i18next";

const words = [
  "programmer?",
  "equipment?",
  "bricklayer?",
  "cleaning?",
  "painter?",
  "carpenter?",
];

const TextZoom = () => {
  const { t } = useTranslation(["Home"]);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [zoomIn, setZoomIn] = useState(true);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down(540));

  useEffect(() => {
    const interval = setInterval(() => {
      // Toggle zoom direction (zoom in or zoom out)
      setZoomIn((prevZoomIn) => !prevZoomIn);

      // Move to the next word if zooming out (going from fully visible to hidden)
      if (!zoomIn) {
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
      }
    }, 1000); // Change zoom direction every 1 second

    return () => {
      // Cleanup interval when the component is unmounted
      clearInterval(interval);
    };
  }, [zoomIn]);

  return (
    <div>
      <h1
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: isSmallScreen ? "30px" : "44px",
        }}
      >
        <span className={styles.heroWordVantar}>{t("missingText")}</span>
        <div style={{ marginLeft: "10px" }}>
          {words.map((word, index) => (
            <Zoom in={index === currentWordIndex && zoomIn} key={index}>
              <h1
                style={{
                  color: "#78ca72",
                  fontSize: isSmallScreen ? "30px" : "44px",
                  display: index === currentWordIndex && zoomIn ? "" : "none",
                }}
              >
                <span className={styles.heroWords}>
                  {t(`zoomTextWords.${word}`)}
                </span>
              </h1>
            </Zoom>
          ))}
        </div>
      </h1>
    </div>
  );
};

export default TextZoom;
